import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { stringify } from 'query-string';
import { useMemo, useCallback, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import VisibilitySensor from 'react-visibility-sensor';
import { propArrayShape, propFunc, propId, } from '../../../../../../helpers/custom-prop-types';
const InterviewContentSticky = (props) => {
    const { id, onClickSendOff: rawOnClickSendOff, selects } = props;
    const inputInterviewUrl = useMemo(() => {
        const query = stringify({ id: selects.map((v) => v.id).join(',') });
        return `/project/client/${id}/interview/input?${query}`;
    }, [id, selects]);
    const onClickSendOff = useCallback(() => {
        rawOnClickSendOff(selects);
    }, [rawOnClickSendOff, selects]);
    const ref = useRef();
    const [isShow, changeIsShow] = useState(false);
    const onChange = useCallback((isVisible) => {
        if (!isVisible) {
            const { y } = ref.current.getBoundingClientRect();
            if (y < 0) {
                return;
            }
        }
        changeIsShow(isVisible);
    }, [changeIsShow, ref]);
    return (_jsx(VisibilitySensor, Object.assign({ active: true, intervalDelay: 10, onChange: onChange, partialVisibility: true }, { children: _jsxs("div", Object.assign({ className: clsx('rfp-content-body-footer-box', isShow && 'is-show'), ref: ref }, { children: [_jsx("div", { className: 'rfp-content-body-footer-space' }), _jsx("div", Object.assign({ className: 'rfp-content-body-footer-fixed' }, { children: _jsxs("div", Object.assign({ className: 'rfp-content-body-footer' }, { children: [_jsxs("div", Object.assign({ className: 'description_box' }, { children: [_jsx("i", { className: 'material-icons check' }), _jsx("span", Object.assign({ className: 'description_text' }, { children: `${selects.length}チーム選択中` }))] })), _jsxs("div", Object.assign({ className: 'action_box' }, { children: [_jsx("button", Object.assign({ className: 'button bulk_send_off', onClick: onClickSendOff, type: 'button' }, { children: "\u4E00\u62EC\u3067\u9762\u8AC7\u3092\u898B\u9001\u308B" })), _jsx(Link, Object.assign({ className: 'button service bulk_interview', to: inputInterviewUrl }, { children: "\u4E00\u62EC\u3067\u9762\u8AC7\u4F9D\u983C\u3092\u3059\u308B" }))] }))] })) }))] })) })));
};
InterviewContentSticky.propTypes = {
    id: propId().isRequired,
    onClickSendOff: propFunc().isRequired,
    selects: propArrayShape().isRequired,
};
export default InterviewContentSticky;
